import { List, Datagrid, NumberField, EditButton, TextField } from "react-admin";
import DisplayDateField from "@/components/DisplayDateField";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useRouteId } from "@/utils/route-utility";

export const ProjectPaymentList = () => {
  const projectId = useRouteId();
  if (!projectId) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography color="text.secondary">
          Open a project from the Projects list to manage work payments.
        </Typography>
      </Box>
    );
  }
  return (
    <List perPage={25} sort={{ field: "paidDate", order: "DESC" }} filter={{ projectId }}>
      <Datagrid rowClick="edit">
        <NumberField source="amount" options={{ style: "currency", currency: "INR" }} />
        <DisplayDateField source="paidDate" />
        <TextField source="payeeName" emptyText="—" />
        <TextField source="purpose" emptyText="—" />
        <TextField source="paymentMode" />
        <EditButton />
      </Datagrid>
    </List>
  );
};
